import React, { useState, useEffect, useRef } from "react";
import "./statistics.css";
import { IoMdPeople } from "react-icons/io";
import { MdPeopleAlt } from "react-icons/md";
import { TfiMenuAlt } from "react-icons/tfi";
import { FaHome } from "react-icons/fa";

function Statistics() {
  const statsData = [
    {
      id: 1,
      icon: <IoMdPeople className="staticIcon" />,
      number: 28,
      label: "Total Vendors",
    },
    {
      id: 2,
      icon: <MdPeopleAlt className="staticIcon" />,
      number: 200,
      label: "Total Clients",
    },

    {
      id: 3,
      icon: <FaHome className="staticIcon" />,
      number: 600,
      label: "Total Leads",
    },
  ];

  const [counts, setCounts] = useState(statsData.map(() => 0));
  const sectionRef = useRef(null);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting && !started) {
          setStarted(true);
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, [started]);

  useEffect(() => {
    if (started) {
      statsData.forEach((stat, index) => {
        let start = 0;
        const end = stat.number;
        const duration = 1500; // 1.5s
        const stepTime = Math.abs(Math.floor(duration / end));

        const timer = setInterval(() => {
          start += 1;
          setCounts((prev) => {
            const updated = [...prev];
            updated[index] = start;
            return updated;
          });

          if (start === end) clearInterval(timer);
        }, stepTime);
      });
    }
  }, [started]);

  return (
    <div
      className="container stisticsBg mt-xl-3 mt-lg-3 mt-md-3 mt-sm-3 mt-2  mb-xl-5 mb-lg-5 mb-md-3 mb-sm-3 mb-2 "
      ref={sectionRef}
    >
      <div className="row ">
        {statsData.map((item, index) => (
          <div
            key={item.id}
            className="col-md-12 col-lg-4  d-flex justify-content-center my-xl-5 my-lg-5 my-md-3 my-sm-2 my-2"
          >
            <div className="d-flex  gap-3">
              <div>{item.icon}</div>
              <div>
                <h3 className="statich3 text-center">{counts[index]}</h3>
                <p className="staticp1">{item.label}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Statistics;
